import type { pilots as en } from '@/i18n/locales/en/pilots';
import type { Translation } from '@/i18n/types';

export const pilots: Translation<typeof en> = {
  page: {
    title: 'Πιλοτικά προγράμματα',
    lead: 'Πιλοτικά προγράμματα στην {{company}}.',
    noScope: 'Επιλέξτε εταιρεία για να δείτε τα πιλοτικά της.',
    listTitle: 'Πιλοτικά προγράμματα',
    empty: 'Δεν υπάρχουν ακόμη πιλοτικά.',
  },
  status: {
    draft: 'Πρόχειρο',
    baseline: 'Αρχική μέτρηση',
    active: 'Ενεργό',
    interim_review: 'Ενδιάμεση αξιολόγηση',
    final_review: 'Τελική αξιολόγηση',
    completed: 'Ολοκληρώθηκε',
    scaled: 'Επεκτάθηκε',
  },
  phases: {
    baseline: 'Αρχική μέτρηση',
    interim: 'Ενδιάμεση αξιολόγηση',
    final: 'Τελική αξιολόγηση',
  },
  kpis: {
    participationRate: 'Ποσοστό συμμετοχής',
    activeUsers: 'Ενεργοί χρήστες',
    dailyUsage: 'Καθημερινή χρήση',
    satisfaction: 'Ικανοποίηση εργαζομένων',
    avgVitality: 'Μέση ζωτικότητα',
    aiCoachUsage: 'Χρήση AI coach',
    challengeUsage: 'Χρήση challenges',
    rolloutReadiness: 'Σύσταση επέκτασης',
  },
  form: {
    title: 'Νέο πιλοτικό',
    name: 'Όνομα',
    startDate: 'Ημερομηνία έναρξης',
    departments: 'Τμήματα',
    submit: 'Δημιουργία πιλοτικού',
  },
  detail: {
    title: 'Πιλοτικό',
    lead: 'Αξιολόγηση του πιλοτικού προγράμματος ζωτικότητας με KPI, τάσεις, συμπεράσματα και μια τεκμηριωμένη απόφαση επέκτασης.',
    exportPdf: 'Εξαγωγή αναφοράς (PDF)',
    hero: {
      badge: {
        success: 'Το πιλοτικό πέτυχε',
        partial: 'Το πιλοτικό σε εξέλιξη',
        atRisk: 'Απαιτείται προσοχή',
        pending: 'Το πιλοτικό εκτελείται',
      },
      goals: {
        success: 'Όλοι οι στόχοι KPI επιτεύχθηκαν',
        partial: 'Μέρος των στόχων KPI επιτεύχθηκε',
        atRisk: 'Οι στόχοι KPI δεν έχουν ακόμη επιτευχθεί',
        pending: 'Δεν υπάρχουν ακόμη αρκετά δεδομένα για σύσταση',
      },
      headlinePrefix: {
        success:
          'Το πιλοτικό αποδεικνύει ότι το NOLATR Fit βελτιώνει μετρήσιμα τη ζωτικότητα — σύσταση:',
        partial: 'Το πιλοτικό δείχνει βελτίωση — σύσταση:',
        atRisk: 'Το πιλοτικό δεν δείχνει ακόμη μετρήσιμη βελτίωση — σύσταση:',
        pending: 'Δεν υπάρχουν ακόμη αρκετά δεδομένα για σύσταση σχετικά με',
      },
      headlineAdvice: {
        success: 'επέκταση σε ολόκληρο τον οργανισμό.',
        partial: 'παράταση του πιλοτικού για περισσότερα δεδομένα.',
        atRisk: 'διόρθωση αυτού πριν από την επέκταση.',
        pending: 'την επέκταση.',
      },
    },
    summary: {
      participation: 'Συμμετοχή',
      dailyActive: 'Καθημερινά ενεργοί',
      stress: 'Άγχος',
      sleep: 'Ύπνος',
      goal: 'στόχος {{value}}%',
      vsBaseline: 'έναντι αρχικής μέτρησης',
      minutes: '{{value}} λεπτά',
    },
    aiSummaryTitle: 'Σύνοψη AI',
    recommendationEmpty: 'Δεν έχει γραφτεί ακόμη σύνοψη.',
    kpisTitle: 'Δείκτες KPI',
    chartTitle: 'Ζωτικότητα & δραστηριότητα κατά τη διάρκεια του πιλοτικού',
    chartCurrent: 'Τρέχον',
    noData: 'Δεν υπάρχουν ακόμη δεδομένα.',
    participantCount: '{{count}} συμμετέχοντες',
    evaluationsTitle: 'Συμπεράσματα & συστάσεις',
    conclusionsTitle: 'Συμπεράσματα',
    recommendationsListTitle: 'Συστάσεις',
    evaluationsEmpty: 'Δεν έχουν καταγραφεί ακόμη αξιολογήσεις.',
    evaluationPhase: 'Φάση',
    evaluationConclusions: 'Συμπεράσματα',
    evaluationRecommendations: 'Συστάσεις',
    decisionTitle: 'Απόφαση',
    scaleRequiresCompleted:
      'Η επέκταση είναι δυνατή μόνο μετά την ολοκλήρωση της τελικής αξιολόγησης.',
  },
  actions: {
    new: 'Νέο πιλοτικό',
    cancel: 'Άκυρο',
    save: 'Αποθήκευση',
    edit: 'Επεξεργασία',
    addEvaluation: 'Προσθήκη αξιολόγησης',
    extend: 'Παράταση',
    scale: 'Επέκταση',
  },
};
